<div class="container py-2">
    <h3>Systemeinstellungen</h3>
    <div class=" form-group">
        <app-input-date name="Hier kann man den Zeitpunkt für die Freischaltung der Anmeldung festlegen" required="true"
                        [withTime]="true" [val]="anmeldungenDatum" (valChanged)="newTime=$event"></app-input-date>
    </div>
    <h3>Alle Daten löschen</h3>
    <p>Mit der Funktion werden alle Daten aus dem System gelöscht. Nur Admins und Mitarbeiter werden nicht gelöscht. Nach dem löschen, werden Sie ausgeloggt und müssen sich neu anmelden.</p>
    <div class="d-flex flex-row align-items-center ">
        <div class="form-group flex-grow-1 mr-2">
            <app-input [(val)]="deleteAllTxt" type="text" name='Bitte im Textfehl "alles-löschen" eingeben und dann auf den Button "Alle Daten löschen" klicken.' placeholder="alles-löschen"></app-input>
        </div>
        <button class="btn btn-danger" (click)="deleteAll()" [disabled]="deleteAllTxt !== 'alles-löschen'" >Alle Daten Löschen</button>
    </div>
</div>
<div style="height:55px;"></div>
<div class="fixed-bottom secondaryBgColor d-flex justify-content-center justify-content-lg-end">
    <button class="btn pcButton m-2" (click)="save()">Speichern</button>
</div>
